import { Routes } from '@angular/router';
import { LoginComponent } from './pages/login/login.component';
import { Error404Component } from './pages/error404/error404.component';
import { AuthGuard } from './guard/auth/auth-guard.guard';
import { MenuComponent } from 'new-sysman-ui';

export const routes: Routes = [
  { path: '', component: LoginComponent },
  {
    path: 'modulos',
    canActivate: [AuthGuard],
    children: [
      { path: '', component: MenuComponent },
      {
        path: 'adminsistema',
        loadChildren: () =>
          import('./pages/modules/adminSistema/admin-sistema.routes').then((m) => m.Admin_Sistema_routes),
      },
      {
        path: 'general',
        loadChildren: () => import('./pages/modules/general/general.routes').then((m) => m.GENERAL_ROUTES),
      },
      {
        path: 'servicios-publicos',
        loadChildren: () =>
          import('./pages/modules/servicios-publicos/servicios-publicos.routes').then(
            (m) => m.SERVICIOS_PUBLICOS_ROUTES,
          ),
      },
      {
        path: 'costos-abc',
        loadChildren: () => import('./pages/modules/costosabc/costos-abc.routes').then((m) => m.COSTOS_ABC_ROUTES),
      },
    ],
  },
  { path: '**', component: Error404Component },
];
